import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { UntypedFormBuilder } from '@angular/forms'

import { environment } from '../../../../environments/environment'
import { modelDefinition } from '../model.definition'
import { caseCreateEditTemplate } from '../../../abacus/templates/case-create-edit.template'
import { CaseCreateEditComponent } from '../../../abacus/components/case-create-edit.component'
import { ResourceDefinition } from '../../../abacus/interfaces/resource-definition.interface'
import { InputType } from '../../../abacus/enums/input-type.enum'
import { Field } from '../../../abacus/interfaces/field.interface'
import { ResourceService } from '../../../abacus/services/resource.service'
import { BreadcrumbService } from '../../../abacus/services/breadcrumb.service'
import { FlashMessageService } from '../../../abacus/services/flash-message.service'

@Component({
  selector: 'app-model-create-edit',
  template: caseCreateEditTemplate
})
export class ModelCreateEditComponent
  extends CaseCreateEditComponent
  implements OnInit
{
  definition: ResourceDefinition = modelDefinition
  showLoaderInsteadOfForm = false
  fields: Field[] = [
    {
      label: 'name',
      property: 'name',
      required: true,
      inputType: InputType.Text
    }
  ]

  constructor(
    formBuilder: UntypedFormBuilder,
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService
  ) {
    super(
      formBuilder,
      router,
      breadcrumbService,
      resourceService,
      flashMessageService,
      activatedRoute
    )
  }

  ngOnInit() {
    this.initCreateEditView()
  }
}
